module.exports = __webpack_public_path__ + "static/media/gold-trophy.93ee69cf.webp";